export const environment = {
    console: false,
    devUser : '',
    devPassword: '',
    production: false,
    API_URL: "https://apipre.apiacpos.com/2_15_0_bridge/",
    CODIGO_APLICACION: "PVKORE",
    ID_APLICACION: "1",
    TPV_PATH: "TPV01",
    chClaveEmpresa: "GUADALPARK",
    chEntornoConexion: "PREPRODUCCION",
    chNombreProyecto: "TAQUILLA",
    chOrigenConexion: "TAQUILLA",
    NUMSERIE:"TAQU$A$N0QBO3AQ0$A$ILLA$A$CVW1R9537",
    ADMIN_AGENDA_URL: "https://admin.guadalpark.iacpospre.com/admin/Agenda.aspx",
    ADMIN_INDEX_URL: "https://admin.guadalpark.iacpospre.com/admin/MenuOperacionesEspeciales.aspx",
    svgFolder: "development",
    API_URL_TAQUILLA: "https://apipre.apiacpos.com/WEBAPICoreBridge_1_7_0",
    API_TOKEN_USER: "admin@admin.com",
    API_TOKEN_PASSWORD: "IACPOS.2023a+",
    API_URL_MS: "https://apipre.apiacpos.com/WEBAPICoreBridge_1_7_0",
};
